$bog_ui_app_empty $mol_page
	title \Empty State
	body /
		<= Description $mol_view
			sub /
				<= description \Placeholder component for empty pages with icon, title, message, and optional action button.
		<= Section_default $mol_view
			sub /
				<= section_default_title \Default
		<= Default $bog_ui_empty
		<= Section_custom $mol_view
			sub /
				<= section_custom_title \Custom Icon
		<= Custom_icon $bog_ui_empty
			Icon <= Custom_icon_icon $mol_icon_folder
			title \No documents
			message \Upload your first document to get started
		<= Section_action $mol_view
			sub /
				<= section_action_title \With Action Button
		<= With_action $bog_ui_empty
			Icon <= Action_icon $mol_icon_plus_circle
			title \No items yet
			message \Create your first item to begin
			Action <= Action_button $mol_button_major
				sub /
					<= action_label \Create Item
